import type { BdrSdr } from '@/types'
import { isHybridBdrCloser, OPERATIONAL_BDR_USER_ID } from '@/utils/operationalUsers'

export const DEFAULT_BDR_ID = OPERATIONAL_BDR_USER_ID

/** Define qual BDR abrir no seletor ao carregar o painel. */
export function resolveDefaultBdrId(
  sdrsList: BdrSdr[],
  user: { id: string; role: string } | null | undefined,
): string {
  const role = user?.role?.toLowerCase()
  const isOversight = role === 'admin' || role === 'manager'

  if (user?.id && isHybridBdrCloser(user.id)) {
    const self = sdrsList.find((s) => s.id === user.id)
    if (self) return self.id
    return DEFAULT_BDR_ID
  }

  if (isOversight) {
    const sophia = sdrsList.find(
      (s) => s.id === DEFAULT_BDR_ID || s.name?.toLowerCase().includes('sophia'),
    )
    if (sophia) return sophia.id
    return DEFAULT_BDR_ID
  }

  if (role === 'bdr' && user?.id) {
    const self = sdrsList.find((s) => s.id === user.id)
    if (self) return self.id
  }

  const sophia = sdrsList.find(
    (s) => s.id === DEFAULT_BDR_ID || s.name?.toLowerCase().includes('sophia'),
  )
  if (sophia) return sophia.id

  if (sdrsList.length > 0) return sdrsList[0].id
  if (role === 'bdr' && user?.id) return user.id
  return DEFAULT_BDR_ID
}
